/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineBatchRequest extends models.BatchRequest {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineBatchRequest>): AIUnitEconomicsBaselineBatchRequest {
        let obj = Object.assign(new AIUnitEconomicsBaselineBatchRequest(), model);
        AIUnitEconomicsBaselineBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineBatchRequest>): AIUnitEconomicsBaselineBatchRequest {
        if (!model) return null;
        return AIUnitEconomicsBaselineBatchRequest.newInstance(<AIUnitEconomicsBaselineBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineBatchRequest) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineBatchRequest): boolean {
        if (models.BatchRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Include the full configuration array in each result. Defaults to false to keep batch responses small
     */
    include_configuration: boolean;

}
